import Vue from "vue";

let $vue = new Vue;

//公共过滤器
const commonFilter = {
    //公顷换算亩
    areaFilter:function(val){
        if(val){
            val = val * 15;
            return val;
        }else{
            return '';
        }
    }
}
export default commonFilter